import { X } from "lucide-react";

// components/CreateUserModal.jsx
const CreateUserModal = ({ open, onClose, onCreate }) => {
  if (!open) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onCreate();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 ">
      <div className="bg-white rounded-xl w-full h-auto max-w-md p-6">
        <div className="flex justify-between">
          <div>
            <h2 className="text-xl font-semibold ">Create User</h2>
            <p className="font-light text-gray-500">
              Fill in the details to create a new project.
            </p>
          </div>
          <div>
            <X onClick={onClose} className=" cursor-pointer" />
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-3 mt-4">
          <div>
            <label className="block font-medium text-gray-500">Name</label>
            <input
              className="w-full border p-2 rounded-md"
              placeholder="Enter your name"
            />
          </div>
          <div>
            <label className="block font-medium text-gray-500 ">
              Last Name
            </label>
            <input
              className="w-full border p-2 rounded-lg"
              placeholder="Enter your last name"
            />
          </div>
          <div>
            <label className="block font-medium text-gray-500 ">Email</label>
            <input
              className="w-full border p-2 rounded-lg"
              placeholder="Enter your email"
            />
          </div>
          <div>
            <label className="block font-medium text-gray-500 ">Age</label>
            <input
              className="w-full border p-2 rounded-lg"
              placeholder="Enter your age"
            />
          </div>
          <div className="flex justify-end gap-2 mt-4">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border rounded"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-black text-white rounded"
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateUserModal;
